module.exports = __webpack_public_path__ + "static/netflix_395x404-67897b7b1276d0cef3019d9cf00a0ea5.png";